import * as React from "react";
import { IdStyles } from "../../../../less/IdStyles";
import { Icon } from "../../../generic/icon/Icon";
import { NumberFormat } from "../../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../../generic/number-format/TypeNumberFormat";
export var BuildingUpgradeEffect = React.memo(function (_a) {
    var icon = _a.icon, amount = _a.amount, format = _a.format;
    // tslint:disable-next-line:no-null-keyword
    return icon.length === 0 ? null : (React.createElement("div", { className: "building-upgrade__effects-item" },
        React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
        amount && (React.createElement("div", { className: IdStyles.TextBoldAccent },
            React.createElement(NumberFormat, { amount: amount, format: format })))));
});
BuildingUpgradeEffect.defaultProps = {
    format: TypeNumberFormat.None,
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/BuildingUpgradeEffect.tsx
// module id = 2862
// module chunks = 3